import React from "react"
import styled from "styled-components"
import map from "lodash/map"
import { Link } from "gatsby"
import { device, toSlug } from "src/utils"

const PostTags = ({ tags, type }) => {
  const renderTags = () =>
    map(tags, (tag, idx) => {
      const slugTag = toSlug(tag)

      return (
        <Link to={`/${type}/${slugTag}`} key={idx}>
          <Tag>{tag}</Tag>
        </Link>
      )
    })
  return <StyledPostTags>{renderTags()}</StyledPostTags>
}

const StyledPostTags = styled.ul`
  padding: 0 !important;
  display: flex;
  flex-wrap: wrap;
  grid-gap: var(--sp-8);
`

const Tag = styled.li`
  list-style-type: none;

  padding: var(--sp-16) var(--sp-24);
  border-radius: 50px;
  background: white;
  box-shadow: var(--card-shadow);
  align-items: center;
  justify-content: center;

  background: none;
  color: var(--body);
  border: 1px solid var(--body);
  text-align: center;
  font-weight: 600;
  transition: 0.2s opacity ease-in-out;

  @media ${device.laptop} {
    &:hover {
      opacity: 0.8;
    }
  }
`

export default PostTags
